import { envConfig } from '../../../../env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton/admin/projectInfo';

export function insertProjectInfo(data) {
    return Post(baseUrl + '/insertProjectInfo', data);
}

export function deleteProjectInfo(data) {
    return Post(baseUrl + '/deleteProjectInfo', data);
}

export function updateProjectInfo(data) {
    return Post(baseUrl + '/updateProjectInfo', data);
}

export function queryProjectInfoList(data) {
    return Post(baseUrl + '/queryProjectInfoList', data);
}

function baseApi() {
    function insert(data) {
        return Post(baseUrl + '/insertProjectInfo', data);
    }

    function deleteData(data) {
        return Post(baseUrl + '/deleteProjectInfo', data);
    }

    function update(data) {
        return Post(baseUrl + '/updateProjectInfo', data);
    }

    function query(data) {
        return Post(baseUrl + '/queryProjectInfoList', data);
    }

    return {
        query,
        update,
        deleteData,
        insert
    }
}

export const projectInfoApi = baseApi()